import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ingestApi } from "../../../api";
import { SourceOrgCategory } from "../../../generated/ingest-api";

export function useApproveVersion(
  category: SourceOrgCategory,
  orgId: string,
  docId: string
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      ingestApi.approveDocumentVersion(category, orgId, docId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["listDocumentVersions", category, orgId, docId],
      });
    },
  });
}
